<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-filter-item-time-range" v-if="filter">
    <el-dropdown-item>
      <span class="filter-title">{{filter.label}}:</span>
      <table border="0" cellpadding="0" cellspacing="0">
      <tr>
        <td><wy-time-picker v-model="filter.value" format="hh:mm:ss" :timePickerInputHasError="filterError.hasError" manual-input hide-dropdown input-width="130px"></wy-time-picker></td>
        <td class="from-to-sign"> - </td>
        <td><wy-time-picker v-model="filter.valueTo" format="hh:mm:ss" :timePickerInputHasError="filterError.hasError" manual-input hide-dropdown input-width="130px"></wy-time-picker></td>
      </tr>
      </table>
    </el-dropdown-item>
  </div>
</template>

<script>
import WyTimePicker from '../wy-time-picker'

export default {
  name: 'wy-filter-item-time-range',
  props: ["filterError", "filter"],
  components: { 
    'wy-time-picker': WyTimePicker
  },
  data() {
    return {
      hasError: false
    }
  },
  watch: {
    filter: {
      handler: function(newValue) {
        this.filterError.hasError = this.checkError(newValue.value, newValue.valueTo);
      },
      deep: true
    }
  },
  methods: {
    checkError(from, to) {
      from = from ? from : {hh: 0, mm: 0, ss: 0};
      to = to ? to : {hh: 0, mm: 0, ss: 0};
      if(from && to) {
        from.hh = (from.hh == '') ? 0 : from.hh
        from.mm = (from.mm == '') ? 0 : from.mm
        from.ss = (from.ss == '') ? 0 : from.ss
        to.hh = (to.hh == '') ? 0 : to.hh
        to.mm = (to.mm == '') ? 0 : to.mm
        to.ss = (to.ss == '') ? 0 : to.ss
        let fromValue = parseInt(from.hh*3600) + parseInt(from.mm*60) + parseInt(from.ss)
        let toValue = parseInt(to.hh*3600) + parseInt(to.mm*60) + parseInt(to.ss)
        return fromValue > toValue
      }
      else {
        return false
      }
    }
  }
}
</script>

